import React, { useState } from "react";
import ProductReport from "../products/ProductReport";

const ProductRecommendationReport = (props) => {
  const element = props.element;
  const product_recommendation = props.product_recommendation;
  const [showProducts, setShowProducts] = useState(false);

  const products = Array.isArray(product_recommendation.products)
    ? product_recommendation.products
    : Object.values(product_recommendation.products || {});
  const row_products = products.filter(
    (product) => product && product.id && product.title
  );

  return (
    <React.Fragment>
      <div
        className="row hard-center element-selection-report"
        data-element-id={element.id}
        style={{
          width: "100%",
          display: row_products.length > 0 ? "block" : "none",
        }}
        data-has-reports={`${row_products.length > 0}`}
        data-report-id-prefix={props.reportIdPrefix || ""}
      >
        <div
          className="row hard-center"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setShowProducts(!showProducts);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" || event.key === " ") {
              event.preventDefault();
              setShowProducts(!showProducts);
            }
          }}
          role="button"
          tabIndex={0}
          aria-expanded={showProducts}
        >
          <div className="col-xs-4 funnel-breakdown-question-label">
            <div
              className="text-xl"
              data-toggle-item-id={product_recommendation.id}
              style={{
                marginBottom: "5px",
                display: "flex",
                alignItems: "center",
              }}
              data-open={`${showProducts}`}
            >
              <span
                className="ellipsis funnel-breakdown-question-text"
                style={{ minWidth: 0 }}
              >
                Product Recommendation - {product_recommendation.options.label}
              </span>
              <span
                className={`glyphicon glyphicon-chevron-${
                  showProducts ? "down" : "right"
                } element-selection-report-toggle ml-1`}
                style={{ flexShrink: 0 }}
              ></span>
            </div>
          </div>
        </div>

        {showProducts && (
          <div
            className="row hard-center"
            style={{
              display: "flex",
              width: "100%",
              flexBasis: "100%",
              flexWrap: "wrap",
              flexDirection: "column-reverse",
              backgroundColor: "#fcfdfe",
              marginTop: "2px",
              paddingTop: "15px",
            }}
          >
            <div className="col-xs-12 element-reports">
              {row_products.map((product) => {
                return (
                  <ProductReport
                    key={`product-report-${product.id}`}
                    product={product}
                    label={product.title}
                    {...props}
                  />
                );
              })}
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default ProductRecommendationReport;
